import { useMemo } from 'react';

import { getCanvasBriefMaxCharCount, getCanvasBriefMaxWordCount } from 'src/data/brief';
import { GENERATION_TOOL } from 'src/data/generationTool';

const DEFAULT_TEXTS = {
  label: 'Free text',
  placeholder: '',
};

const getLabels = (generationTool) => {
  switch (generationTool) {
    case GENERATION_TOOL.basicContentImprover:
      return {
        ...DEFAULT_TEXTS,
        label: 'Copy to improve',
        placeholder:
          'Discourse analysis is concerned with the interpretation of entire texts rather than the smaller units of language that other subfields of linguistics often focus on.\n' +
          'However, due to the vast amount of differing methodologies, it can often be difficult for analysts to reach a consensus.',
      };

    case GENERATION_TOOL.basicEli5:
      return {
        ...DEFAULT_TEXTS,
        label: 'Content',
        placeholder:
          'People have trouble sticking to their budgets for various reasons, so getting on track will depend on your particular struggles.',
      };

    case GENERATION_TOOL.basicSentenceExpander:
      return {
        ...DEFAULT_TEXTS,
        label: 'Sentence to expand on',
        placeholder:
          'Make a habit out of improving productivity, reducing expenses, and making data-driven decisions.',
      };

    case GENERATION_TOOL.basicVideoIdeas:
      return {
        ...DEFAULT_TEXTS,
        label: 'Video topic',
        placeholder: 'Cooking hacks',
      };

    case GENERATION_TOOL.basicBlogIdeas:
      return {
        ...DEFAULT_TEXTS,
        label: 'Blog post topic',
        placeholder: 'Urban gardening for beginners',
      };

    case GENERATION_TOOL.basicTalkingPointsToParagraph:
      return {
        ...DEFAULT_TEXTS,
        label: 'Talking points',
        placeholder:
          'AI can help copywriters:\n' +
          '- helps to overcome writer’s block \n' +
          '- saves time and effort',
      };

    case GENERATION_TOOL.summarizer:
      return {
        label: 'Text to summarize',
        placeholder:
          'Discourse analysis is concerned with the interpretation of entire texts rather than the smaller units of language that other subfields of linguistics often focus on.\n' +
          'However, due to the vast amount of differing methodologies, it can often be difficult for analysts to reach a consensus.',
      };

    case GENERATION_TOOL.articleBlogHeadline:
      return {
        label: 'Article/Blog to generate a headline for',
        placeholder:
          'Discourse analysis is concerned with the interpretation of entire texts rather than the smaller units of language that other subfields of linguistics often focus on.\n' +
          'However, due to the vast amount of differing methodologies, it can often be difficult for analysts to reach a consensus.',
      };

    case GENERATION_TOOL.basicPersonalBio:
      return {
        label: 'Personal Information',
        placeholder:
          'My name is Jonas\n' +
          "Bachelor's Degree in Coffee Design from UCoffee\n" +
          'Currently working as a Coffee taster\n' +
          'Backed by numerous companies',
      };

    case GENERATION_TOOL.basicCompanyBio:
      return {
        label: 'Business Information',
        placeholder:
          'Founded in 1867\n' +
          'AnyCoffee was started by a group of coffee enthusiasts\n' +
          'Today, AnyCoffee is known for our commitment to quality and taste',
      };

    case GENERATION_TOOL.basicEngagingQuestions:
      return {
        label: 'Topic',
        placeholder: 'Hungarian Linguistics',
      };

    case GENERATION_TOOL.basicQuoraAnswers:
      return {
        label: 'Question',
        placeholder: 'What is the airspeed velocity of an unladen swallow?',
      };

    default:
      return DEFAULT_TEXTS;
  }
};

export const useLabels = (generationTool) =>
  useMemo(() => getLabels(generationTool), [generationTool]);

export const useMaxCharCount = (generationTool) =>
  useMemo(() => getCanvasBriefMaxCharCount(generationTool), [generationTool]);

export const useMaxWordsCount = (generationTool) =>
  useMemo(() => getCanvasBriefMaxWordCount(generationTool), [generationTool]);

export const getFreeTextRowsCount = (generationTool) => {
  if ([GENERATION_TOOL.basicBlogIdeas, GENERATION_TOOL.basicVideoIdeas].includes(generationTool)) {
    return 1;
  }

  return 4;
};
